import * as toolbox from 'components/common/toolbox';
import ActivityLog from 'components/activity-log/activity-log';
import AttachmentsTab from 'components/attachments/attachments-tab';
import Authorize from 'components/common/authorize';
import Badge from 'components/common/Badge';
import CatchErrors from 'components/common/catch-errors';
import LineItems from 'components/line-items/line-items-tab/line-items';
import React from 'react';
import { Ibox } from 'enspire-manager-framework';
import { LOG, PERMISSIONS } from 'components/constants';
import { Route, Link, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';

export default function QuoteTabs(props) {

	/* Hooks ------------------------------------------------------------------------------------------------------------------------------------*/

    const params = useParams();
	const user = useSelector(store => store.users?.user);
	const user_permissions = useSelector(store => store.users?.user_permissions);
	const quotes = useSelector((store) => store.quotes);
	const quote = useSelector((store) => store.quotes.quote);

	// Permissions ----------------------------------------

	const canView = (quote?.ownerId == user?.email || user_permissions[PERMISSIONS.QUOTES_VIEW.key]);
	const canEdit = (quote?.ownerId == user?.email || user_permissions[PERMISSIONS.QUOTES_EDIT.key]);
	
    // Functions ------------------------------------------

	function tab_active(value) {
		return (props.match.params.tab === value) ? ' active' : ''; // returns 'active' if value tab is active
	}
	function tab_url(value) {
		return toolbox.modifyPath(props.location.pathname, seg, value, seg);
	}

	/* Constants ------------------------------------------------------------------------------------------------------------------------------------*/

	const seg = 11;

	/* Render ------------------------------------------------------------------------------------------------------------------------------------*/

	return (
		<>
			<Route path={props.match.path} render={(route_props) =>

				<div className="tabs-container" style={{ marginTop: '20px' }}>
					<ul className="nav nav-tabs underline" role="tablist">
						<li className="position-relative"
							><Link className={'nav-link' + tab_active('items')} to={tab_url('items')} replace={true}>
								<Badge type={'info'} number={quote?.serviceItems?.length || 0} />
								<i title="Line Items" className="fa-duotone fa-solid fa-list-ul fa-2x m-0"></i>
								<br />ITMS
							</Link>
						</li>
						<li className="position-relative">
							<Link className={'nav-link' + tab_active('attachments')} to={tab_url('attachments')} replace={true}>
								<Badge type={'info'} number={quotes?.quote_attachments?.length || 0} />
								<i title="Attachments" className="fa-duotone fa-solid fa-paperclip fa-2x m-0"></i>
								<br />ATT
							</Link>
						</li>
					</ul>

					<div className="tab-content">

						<div role="tabpanel" className={'tab-pane' + tab_active('items')}>
							<div className="panel-body">
								<Route path={props.match.path} render={(route_props) =>
									<CatchErrors>
										<LineItems {...route_props} source="quotes" setFocused={ props.setFocused } permissions={{ canView, canEdit }} />
									</CatchErrors>
								} />
							</div>
						</div>
						<div role="tabpanel" className={'tab-pane' + tab_active('attachments')}>
							<div className="panel-body">
								<Route path={props.match.path} render={(route_props) =>
									<CatchErrors>
										<AttachmentsTab {...route_props} 
											id={ params.quote_id } 
											columnId="column4"
                                            name="Quote" 
											permissions={{ canView, canEdit }}
											source="quotes" 
											singular="quote" 
											store="quotes" 
											prefix="QUOTE" 
                                            setFocused={ props.setFocused }
										/>
									</CatchErrors>
								} />
							</div>
						</div>
					</div>
				</div>
			} />
		</>
	);
};